import { logEvent } from '@eventbrite/statsig';
import { HEAP_EVENT_CLICK } from '../../constants/analytics';
import { EventTrackingMetaData } from './types';

import {
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    isCategory,
} from '@eventbrite/categories';

/**
 * Formats statsig metadata to a string to match
 * expected API formatting.
 *
 * @param eventData
 * @returns
 */
function formatEventMetaData(eventData: EventTrackingMetaData) {
    return {
        isPromoted: `${Boolean(eventData.isPromoted)}`,
        isFree: `${Boolean(eventData.isFree)}`,
        isOnline: `${Boolean(eventData.isOnlineEvent)}`,
        hasUrgencySignals: `${Boolean(eventData.hasUrgencySignals)}`,
    };
}

export function logStatsigClick(
    statsigLocationString: string,
    metaData: EventTrackingMetaData,
) {
    logEvent(
        `${statsigLocationString} - ${HEAP_EVENT_CLICK}`,
        undefined,
        formatEventMetaData(metaData),
    );
}

export function formatVenueToCityRegion({
    venue,
    isOnlineEvent,
}: Pick<EventTrackingMetaData, 'isOnlineEvent' | 'venue'>) {
    if (isOnlineEvent) return 'online';
    if (!venue) return null;
    return [venue.address.city, venue.address.region].join(', ');
}

export function formatPaidStatus(
    isFree: Pick<EventTrackingMetaData, 'isFree'>['isFree'],
) {
    return isFree ? 'free' : 'paid';
}

/**
 * Filters a list of tags and returns the first category
 */
export function formatCategoryFromTags(
    tags?: Pick<EventTrackingMetaData, 'tags'>['tags'],
) {
    if (!tags) return null;
    const category = tags.find((tag) => isCategory(tag));
    if (!category) return null;
    return EVENTBRITE_CATEGORY_TO_REFINEMENT[category];
}
